<template>
  <div class="edit-modal-wrap">
    <el-dialog
      :title="modalTitle"
      :visible.sync="dialogVisible"
      width="900px"
      @closed="modalClosed"
      @open="initSelect"
      :close-on-click-modal="false"
    >
      <div class="modal-body">
        <div class="form-content">
          <el-form :rules="rules" ref="formRef" :model="formData" label-width="160px">
            <el-form-item prop="transferName">
              <span slot="label"> <span style="color: red">*</span> 转化名称 :</span>
              <el-input
                :disabled="isEdit"
                v-model="formData.transferName"
                placeholder="请输入转化名称"
                maxlength="100"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item prop="accountId">
              <span slot="label"> <span style="color: red">*</span> 广告账户 :</span>
              <el-select
                :disabled="isEdit"
                style="width: 100%"
                v-model="formData.accountId"
                filterable
              >
                <el-option
                  v-for="item of countList"
                  :key="item.advertiserId"
                  :value="item.advertiserId"
                  :label="item.company + '-' + item.advertiserName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="转化类型 :">
              <el-radio-group v-model="formData.transfertype">
                <el-radio label="AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD" :disabled="isEdit"
                  >应用</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="应用转化 :">
              <el-radio-group v-model="formData.productTransfer">
                <el-radio label="GOOGLEPLAY" :disabled="isEdit">Google Play</el-radio>
              </el-radio-group>
              <el-radio-group
                size="mini"
                style="display: block"
                v-model="formData.googlePlay"
                @change="formData.clickTimeRange === ''"
              >
                <el-radio-button label="INSTALLCOUNT" :disabled="isEdit">安装次数</el-radio-button>
                <el-radio-button label="APPBUY" :disabled="isEdit">应用内购买</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="appName">
              <span slot="label"> <span style="color: red">*</span> 推广应用 :</span>
              <el-select
                :disabled="isEdit"
                style="width: 100%"
                v-model="formData.appName"
                @change="fillPackageData"
                filterable
              >
                <el-option
                  v-for="item of appList"
                  :key="item.app_cloud_id"
                  :value="item.app_name"
                  :label="item.app_name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="worth" v-if="formData.googlePlay === 'INSTALLCOUNT'">
              <span slot="label"> <span style="color: red">*</span> 价值 :</span>
              <el-radio-group v-model="formData.worth">
                <el-radio label="NO" :disabled="isEdit">不为此转化操作指定价值</el-radio>
                <el-radio label="YES" :disabled="isEdit">为每种转化操作指定价值</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="statisticalMethod" v-else>
              <span slot="label"> <span style="color: red">*</span> 价值 :</span>
              <el-radio-group v-model="formData.statisticalMethod">
                <el-radio label="USUALLY" :disabled="isEdit"
                  >每一次 (对于购买类转化，建议选择此选项，因为每一次购买都会带来价值)</el-radio
                >
                <el-radio label="ONCE" :disabled="isEdit" style="margin-top: 8px">
                  仅一次
                  (对于潜在客户”、“注册及其他转化，建议选择此选项，因为只有第一次互动会带来价值)
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item>
              <span slot="label" style="font-weight: 600"> 转化时间范围</span>
            </el-form-item>
            <el-form-item prop="clickTimeRange">
              <span slot="label"> <span style="color: red">*</span> 点击型转化时间范围 :</span>
              <el-select
                :disabled="isEdit"
                style="width: 100%"
                v-model="formData.clickTimeRange"
                v-if="formData.googlePlay === 'INSTALLCOUNT'"
              >
                <el-option value="30day" label="30天"></el-option>
                <el-option value="1week" label="1周"></el-option>
              </el-select>
              <el-select
                v-else
                :disabled="isEdit"
                style="width: 100%"
                v-model="formData.clickTimeRange"
              >
                <el-option
                  v-for="item of clickTimeRangeOptions"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="viewTimeRange">
              <span slot="label"> <span style="color: red">*</span> 浏览型转化时间范围 :</span>
              <el-select :disabled="isEdit" style="width: 100%" v-model="formData.viewTimeRange">
                <el-option value="1day" label="1天"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="footer-wrap">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button @click="submitData" type="primary" v-show="!isEdit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAdCount, createConvert } from "@/api/property.js";
import { getCommonProductList } from "@/api/api.js";
import { clickTimeRangeOptions } from "../../config";
export default {
  data() {
    return {
      isEdit: false,
      dialogVisible: false,
      modalTitle: "新建转化",
      countList: [],
      appList: [],
      clickTimeRangeOptions,
      formData: {
        transferName: "",
        accountId: null,
        transfertype: "AD_CONVERT_SOURCE_TYPE_APP_DOWNLOAD",
        productTransfer: "GOOGLEPLAY",
        googlePlay: "INSTALLCOUNT",
        appName: "",
        worth: "NO",
        statisticalMethod: "USUALLY",
        clickTimeRange: "",
        viewTimeRange: "",
      },
      rules: {
        transferName: [{ required: true, message: "请输入转化名称", trigger: "change" }],
        accountId: [{ required: true, message: "广告账户", trigger: "change" }],
        appName: [{ required: true, message: "请输入应用名称", trigger: "change" }],
        package_name: [{ required: true, message: "请输入包名", trigger: "change" }],
        clickTimeRange: [
          { required: true, message: "请选择点击型转化时间范围", trigger: "change" },
        ],
        viewTimeRange: [{ required: true, message: "请选择浏览型转化时间范围", trigger: "change" }],
      },
    };
  },
  methods: {
    addTransform() {
      this.isEdit = false;
      this.dialogVisible = true;
    },
    checkTransform(data) {
      this.formData.transfertype = data.transfertype;
      this.formData.accountId = data.accountId;
      this.formData.appName = data.appName;
      this.formData.package_name = data.package_name;
      this.formData.name = data.name;
      this.formData.download_url = data.download_url;
      this.formData.convert_type = data.convert_type;
      this.formData.deep_external_action = data.deep_external_action
        ? data.deep_external_action
        : "NONE";
      this.formData.action_track_url = data.action_track_url;
      this.formData.display_track_url = data.display_track_url;
      this.isEdit = true;
      this.dialogVisible = true;
    },
    initSelect() {
      getAdCount().then((res) => {
        if (res.code === "0000") {
          this.countList = res.advertiseInfos;
        }
      });
      getCommonProductList({
        platType: 5,
      }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
    },
    fillPackageData(appName) {
      let app = this.appList.find((item) => item.app_name === appName);
      if (app) {
        this.formData.package_name = app.package_name;
      }
    },
    submitData() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          createConvert(this.formData).then((res) => {
            if (res.code === "0000") {
              this.dialogVisible = false;
              this.$message({
                message: "新增应用转化成功",
                type: "success",
              });
              this.$emit("refreshList");
            }
          });
        }
      });
    },
    modalClosed() {
      this.$refs.formRef.resetFields();
    },
    linkCheck(rule, value, callback) {
      if (!/^https:\/\/.+\..+/.test(value)) {
        callback(new Error("请输入正确的https协议链接"));
      } else {
        callback();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  .form-content {
    /deep/ .el-radio__input.is-checked .el-radio__inner {
      color: rgba(24, 144, 255, 1);
      border-color: rgba(24, 144, 255, 1);
      background: rgba(24, 144, 255, 1);
    }
    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: rgba(24, 144, 255, 1);
    }
  }
  .footer-wrap {
    text-align: right;
    padding-bottom: 24px;
  }
}
</style>
